import { settingsFeature } from './settings.reducer';
import { createSelector } from '@ngrx/store';

export const { selectOnline, selectTheme, selectThemes, selectMiniSideNav, selectLanguage, selectPageSize } = settingsFeature;

export const selectIsNetworkOffline = createSelector(selectOnline, (online) => !online);
